
import { Component, Prop, Vue, } from 'vue-property-decorator';

export const ValidSizes = [
	'sm',
	'lg',
] as const;

@Component
export default class IconButton extends Vue {

	@Prop({
		type: String,
		required: true,
		validator(value) {
			return typeof value === 'string' && (ValidSizes as readonly string[]).includes(value);
		},
	})
	size!: UnpackedArray<typeof ValidSizes>;

	clicked(...args: unknown[]) {
		this.$emit('click', ...args);
	}
}
